import { render } from "./VerCreditos.vue?vue&type=template&id=54f964b0"
import script from "./VerCreditos.vue?vue&type=script&lang=js"
export * from "./VerCreditos.vue?vue&type=script&lang=js"

import "./VerCreditos.vue?vue&type=style&index=0&id=54f964b0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__